import http from '../utils/http';
import i18n from '@/main';

const URL_BASE = 'transacao';

export default {
    getOperationsByWarehouseFilter(body, page, size) {
        return http.post({
            url: `${URL_BASE}/transacao-grid-paginado?page=${page}&size=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoesArmazens')
        });
    },
    getCountPendentOperations(operationTypeId = '') {
        return http.get({
            url: `${URL_BASE}/quantidade-pendentes?idTipoTransacao=${operationTypeId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoesArmazensPendentes')
        });
    },
    getTransactionTerritories(id, page, size) {
        return http.get({
            url: `${URL_BASE}/${id}/territorios?page=${page}&size=${size}`,
            lockScreen: false
        });
    },
    getCountReprovedOperations(operationTypeId = '') {
        return http.get({
            url: `${URL_BASE}/quantidade-reprovadas?idTipoTransacao=${operationTypeId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoesArmazensPendentes')
        });
    },
    getTraceabilityContractTotalizer() {
        return http.get({
            url: `${URL_BASE}/totalizadores`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoesArmazensPendentes')
        });
    },
    getTraceabilityContractPdf(idTransacao) {
        return http.get({
            url: `${URL_BASE}/${idTransacao}/contrato-pdf`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacaoArmazemDocumento'),
            responseType: 'blob'
        });
    },
    getTraceabilityReportPdf(idTransacao) {
        return http.get({
            url: `${URL_BASE}/${idTransacao}/relatorio-pdf`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacaoArmazemDocumento'),
            responseType: 'blob'
        });
    },
    getProductList(idTransacao) {
        return http.get({
            url: `${URL_BASE}/listar-produto/${idTransacao}`,
            lockScreen: false
        });
    }
};
